import { css } from "lit";

export const styles = css`
  :host {
    display: block;
  }

  :host([disabled]) {
    opacity: 0.5;
    filter: grayscale(0.4);
  }

  .go-live-label {
    text-transform: none;
  }

  .confirmation-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 0;
  }

  .confirmation-content p {
    margin: 0;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
  }

  .confirmation-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;
